if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cartCrossSell = document.querySelector('cart-cross-sell');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

       const bundleSecondQuantitySelector = document.getElementById('secondProductBundleQS') || null;
       var secondVariantsSelectedId = "";

       if(bundleSecondQuantitySelector != null && secondVariantsChecked == true) {
         const secondBundleInputs = document.querySelectorAll('#secondProductBundleQS input');
         secondBundleInputs.forEach((input) => {
            if(input.checked == true){
              secondVariantsSelectedId = input.dataset.variantId;
              if(thirdVariantsChecked != true) {
                config.body.set('items[1][id]', secondVariantsSelectedId);
                config.body.set('items[1][quantity]',1);
              }
            }
          });
       }

       const bundleThirdQuantitySelector = document.getElementById('troisiemeProductBundleQS') || null;

       if(bundleThirdQuantitySelector != null && thirdVariantsChecked == true) {
        const thirdBundleInputs = document.querySelectorAll('#troisiemeProductBundleQS input');
        thirdBundleInputs.forEach((input) => {
           if(input.checked == true){
            if(secondVariantsSelectedId == input.dataset.variantId){
              console.log('secondVariantsSelectedId == input.dataset.variantId')
              config.body.set('items[1][id]', secondVariantsSelectedId);
              config.body.set('items[1][quantity]',2);
            } else {
              config.body.set('items[1][id]', secondVariantsSelectedId);
              config.body.set('items[1][quantity]',1);
              config.body.set('items[2][id]', input.dataset.variantId);
              config.body.set('items[2][quantity]',1);
            }
           }
         });
      }

      // logic to include the second product if defined in the cart
      const VariantRadiosSecondProduct = document.querySelector('variant-radios-second-product') || null;
      if(VariantRadiosSecondProduct != null) {
        const secondProductVariant = VariantRadiosSecondProduct.currentVariant;
        if(secondProductVariant != null) {
          config.body.set('items[1][id]', secondProductVariant.id);
          config.body.set('items[1][quantity]',1);
        }
      }

      // logic to include the third product if defined in the cart
      const VariantRadiosThirdProduct = document.querySelector('variant-radios-third-product') || null;
      if(VariantRadiosThirdProduct != null) {
        const thirdProductVariant = VariantRadiosThirdProduct.currentVariant;
        if(thirdProductVariant != null) {
          config.body.set('items[2][id]', thirdProductVariant.id);
          config.body.set('items[2][quantity]',1);
        }
      }

      // logic to include the fourth product if defined in the cart
      const VariantRadiosFourthProduct = document.querySelector('variant-radios-fourth-product') || null;
      if(VariantRadiosFourthProduct != null) {
        const fourthProductVariant = VariantRadiosFourthProduct.currentVariant;
        if(fourthProductVariant != null) {
          config.body.set('items[3][id]', fourthProductVariant.id);
          config.body.set('items[3][quantity]',1);
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { 
                this.cart.renderContents(response) 
                if(this.cartCrossSell) {
                  this.cartCrossSell.openModal();
                  this.cartCrossSell.renderContents(response);
                } 
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            if(this.cartCrossSell) {
              this.cartCrossSell.openModal(); 
              this.cartCrossSell.renderContents(response);
            }            
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          initSwiperPicto();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
